module.exports = __webpack_public_path__ + "img/login-img.ea7c6dc9.png";